import { render } from "./OptionCardSpecial.vue?vue&type=template&id=3b62b818"
import script from "./OptionCardSpecial.vue?vue&type=script&lang=js"
export * from "./OptionCardSpecial.vue?vue&type=script&lang=js"

import "./OptionCard.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__